import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "button-text" }

import { computed } from 'vue';
import MicOutlineIcon from "../../assets/images/MicOutlineIcon.svg"
import UploadIcon from "../../assets/images/Upload-black.svg";
import FolderIcon from "../../assets/images/FolderDarkIcon.svg"


export default /*@__PURE__*/_defineComponent({
  __name: 'ActionButton',
  props: {
    type: {},
    onClick: { type: Function },
    label: {}
  },
  setup(__props: any) {


const props = __props

const handleKeyPress = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
        event.preventDefault();
        props.onClick();
        (event.target as HTMLElement).blur();
    }
}

const buttonConfig = computed(() => {
    switch (props.type) {
        case 'record':
        return {
            text: 'Record',
            color: '#e7b2ef',
            image: MicOutlineIcon,
        }
        case 'upload':
        return {
            text: 'Upload',
            color: '#b8df94',
            image: UploadIcon
        }
        case 'newfolder':
        return {
            text: 'New Folder',
            color: '#a0c1f6',
            image: FolderIcon
        }
        default:
        return {
            text: 'Default',
            color: 'gray',
            image: ''
        }
    }
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    style: _normalizeStyle({ backgroundColor: buttonConfig.value.color }),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (props.onClick && props.onClick(...args))),
    class: "session-action-button",
    "aria-labelledby": props.label,
    onKeydown: _cache[1] || (_cache[1] = () => handleKeyPress)
  }, [
    (buttonConfig.value.image)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: buttonConfig.value.image,
          alt: "button icon",
          class: "button-image",
          role: "presentation"
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_3, _toDisplayString(buttonConfig.value.text), 1)
  ], 44, _hoisted_1))
}
}

})